module.exports = __webpack_public_path__ + "static/media/slot-payment.00716ce5.svg";